import React from 'react';

const Forum = () => {
  return (
    <div className="pt-20">
      <h1>Forum Page</h1>
      <p>Connect with the ContextUI community for discussions and troubleshooting</p>
    </div>
  );
};

export default Forum;